import { useCookies } from "react-cookie";
import { createSearchParams, useLocation } from "react-router";

interface UseHashIdReturn {
  hashId: string | null;
  hashIdCookie: string | null;
  setHashId: (id: string) => void;
  removeHashId: () => void;
}

const useHashId = (): UseHashIdReturn => {
  const [cookies, setCookie, removeCookie] = useCookies(["hashId"]);
  const hashIdCookie = cookies.hashId;
  const params = useLocation();
  const hashId = createSearchParams(params.search).get("hashId");
  const removeHashId = () => removeCookie("hashId", { path: "/" });
  const setHashId = (id: string) => setCookie("hashId", id, { path: "/" });

  return {
    hashId,
    hashIdCookie,
    setHashId,
    removeHashId,
  };
};

export default useHashId;
